export default __webpack_public_path__ + "static/media/7_party_rate.33966444.svg";